import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';


import FuelTankOverview from './FuelTankOverview';

class FuelTankList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fuelTanks: [],
    };
  }

  componentWillMount() {
    this.fetchData(this);
  }

  fetchData() {
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${this.props.fboId}/fuel_farms/${this.props.ownerId}/fuel_tanks`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    this.request = Api.get(endPoint, {
      headers: myHeaders,
    }).then((response) => {
      const fuelTanks = response.fuelTanks;

      this.setState({ fuelTanks });
    });
  }

  renderNoFuelTanks() {
    return (
      <section className="page-content-items">
        Your Fuel Farm has no fuel tanks. Please add one to get started.
      </section>
    );
  }

  renderFuelTanks() {
    return (
      this.state.fuelTanks.map((fuelTank, i) =>
        <FuelTankOverview key={fuelTank.id} fuelTank={fuelTank} fboId={this.props.fboId} ownerName={fuelTank.name} ownerId={this.props.ownerId} ownerType={this.props.ownerType} />)
    );
  }

  render() {
    return (
      <section className="fuel-item-list">
        {this.state.fuelTanks.length > 0 ? (
          this.renderFuelTanks()
        ) : (
          this.renderNoFuelTanks()
        )}
      </section>
    );
  }
}

FuelTankList.propTypes = {
  fboId: PropTypes.number.isRequired,
  ownerId: PropTypes.number.isRequired,
  ownerType: PropTypes.string.isRequired,
};

export default FuelTankList;



// WEBPACK FOOTER //
// ./src/Containers/FuelTanks/FuelTankList.js